import { createSelector } from 'reselect';

import { BUMP_REDUCER_KEY } from './bumpTypes';

export const getStore = (state) => state[BUMP_REDUCER_KEY];

export const getBumpSocketState = (state) => getStore(state).socketState;

export const doesBumpRequireOpening = createSelector(getBumpSocketState, (socketState) => socketState === 'CLOSED');

export const doesBumpRequireAuthentication = createSelector(
  getBumpSocketState,
  (socketState) => socketState === 'OPEN',
);

export const isBumpAuthenticed = createSelector(getBumpSocketState, (socketState) => socketState === 'AUTHENTICATED');
